import { useApp } from "../contexts/AppContext";

const statusClass = s => ({
  "Planning":    "s-plan",
  "In Progress": "s-prog",
  "Pending":     "s-pend",
  "Ongoing":     "s-on",
  "Complete":    "s-done",
}[s] || "s-plan");

export default function ProjectsPage() {
  const { projects } = useApp();

  return (
    <div>
      <div className="pg-hdr">
        <h1>Projects &amp; Initiatives</h1>
        <p>LHDA advances multiple parallel workstreams toward the development of the Lomban Hydropower Project and community benefit programs.</p>
      </div>
      <section className="sec">
        <div className="container">
          <div className="grid2">
            {projects.filter(p => p.published).map(p => (
              <div key={p.id} className="proj-card">
                <div className="proj-hd">
                  <h3 style={{ fontSize: "1.05rem", color: "var(--dk)" }}>{p.title}</h3>
                  <span className={`sbadge ${statusClass(p.status)}`}>{p.status}</span>
                </div>
                <div style={{ display:"flex", gap:"1rem", marginBottom:".75rem", flexWrap:"wrap" }}>
                  <span style={{ fontSize:".77rem", color:"var(--gr)" }}>📅 {p.year}</span>
                  {p.location && <span style={{ fontSize:".77rem", color:"var(--gr)" }}>📍 {p.location}</span>}
                </div>
                <p style={{ fontSize:".88rem", color:"var(--gr)", lineHeight:1.65 }}>{p.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
